module.exports = __webpack_public_path__ + "img/credit-card.0ca1fa01.png";